import { render, staticRenderFns } from "./ApprovalNodeConfig.vue?vue&type=template&id=43e66396&scoped=true"
import script from "./ApprovalNodeConfig.vue?vue&type=script&lang=js"
export * from "./ApprovalNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./ApprovalNodeConfig.vue?vue&type=style&index=0&id=43e66396&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e66396",
  null
  
)

export default component.exports